import { render, staticRenderFns } from "./Equipo_Icono.vue?vue&type=template&id=553f1350&scoped=true&"
import script from "./Equipo_Icono.vue?vue&type=script&lang=js&"
export * from "./Equipo_Icono.vue?vue&type=script&lang=js&"
import style0 from "./Equipo_Icono.vue?vue&type=style&index=0&id=553f1350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f1350",
  null
  
)

export default component.exports